(() => {
  const className = 'swinger-loading-indicator';
  const getElem = () => document.getElementById(`${className}`);
  let count = 0;
  let timer;

  document.addEventListener(`${className}:show`, () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      count = 0;
      const elem = getElem();
      if (!elem) {
        return;
      }
      elem.classList.remove(`${className}--is-shown`);
    }, 5000);
    count += 1;
    getElem().classList.add(`${className}--is-shown`);
  });

  document.addEventListener(`${className}:hide`, () => {
    count -= 1;
    window.setTimeout(() => {
      if (count <= 0) {
        count = 0;
        const elem = getElem();
        if (!elem) {
          return;
        }
        elem.classList.remove(`${className}--is-shown`);
      }
    }, 100);
  });
})();
